import { useEffect, useState } from "react";
import { Plus, Minus } from "lucide-react";
import { api, whatsappLink } from "@/lib/api";

export default function Faqs() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data.faqs || []));
  }, []);

  return (
    <div data-testid="faqs-page">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-16">
        <div className="overline">Frequently, gently asked</div>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl lg:text-7xl font-light text-[#1B3B36] leading-[1.02] tracking-tight max-w-4xl">
          The <em className="italic text-[#84968C]">small print,</em> in plain words.
        </h1>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8">
          <ul className="divide-y divide-[#D8D4CC] border-t border-[#1B3B36]">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <li key={i}>
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-start justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-serif text-2xl md:text-3xl text-[#1B3B36] leading-tight">
                      {f.q}
                    </span>
                    <span className="mt-2 flex-shrink-0 w-9 h-9 border border-[#1B3B36] text-[#1B3B36] flex items-center justify-center">
                      {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-500 ${
                      isOpen ? "grid-rows-[1fr] pb-6" : "grid-rows-[0fr]"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p
                        data-testid={`faq-answer-${i}`}
                        className="text-[15px] leading-relaxed text-[#4A4A4A] font-light max-w-2xl"
                      >
                        {f.a}
                      </p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <aside className="lg:col-span-4">
          <div className="border border-[#D8D4CC] p-8 bg-[#EFECE5]/40 sticky top-28">
            <div className="overline">Still curious?</div>
            <div className="mt-4 font-serif text-3xl text-[#1B3B36] leading-tight">
              Ask a maker directly.
            </div>
            <p className="mt-4 text-[14px] text-[#4A4A4A] font-light">
              Our design lead is on WhatsApp between 10.00 – 19.00 IST and
              usually replies within an hour.
            </p>
            <a
              href={whatsappLink(
                "Hello Iryaa Homes, I have a question about a piece."
              )}
              target="_blank"
              rel="noreferrer"
              data-testid="faqs-whatsapp"
              className="mt-6 inline-flex w-full items-center justify-center gap-3 bg-[#1B3B36] text-[#F9F8F6] px-6 py-4 text-[12px] tracking-[0.22em] uppercase hover:bg-[#132A26]"
            >
              WhatsApp our studio
            </a>
          </div>
        </aside>
      </section>
    </div>
  );
}
